module.exports = __webpack_public_path__ + "static/media/open-pilot.7cce4e5c.jpg";